<template>
  <div>
    <mdb-tbl v-if="mode==='LIST'" class="ml-3 my-2 fsize-m" sm >
      <mdb-tbl-head>
        <tr class="">
          <th>과목명</th><th>단원수</th><th>평가기준</th><th>1차 평가</th><th>2차 평가</th>
        </tr>
      </mdb-tbl-head>
      <mdb-tbl-body>
        <tr v-for="(s, i) in $normalSubjects(subjects)" :key="i">
          <td class="bolder"><mdb-icon icon="chalkboard-teacher" /> {{s.name}}</td>
          <td>{{s.lectures.length}}</td>
          <td class="text-center"><edit-btn-sm v-if="isTest(s.name, 1)" @click="onEditTestUnit(s.name)"/></td>
          <td>
            <div v-if="isTest(s.name, 1)" class="pointer">
              <span  @click="onEdit(s.name, 1)">{{$strDate(task1(s.name).testDate)}}</span>
              <delete-btn-xs class="ml-2" @click="onDelete(s.name, 1)"/>
            </div>
            <div v-else><add-btn-sm  @click="onAdd(s.name, 1)">만들기</add-btn-sm></div>
          </td>
          <td>
            <div v-if="isTest(s.name, 2)" class="pointer">
              <span @click="onEdit(s.name, 2)">{{$strDate(task2(s.name).testDate)}}</span>
              <delete-btn-xs class="ml-2" @click="onDelete(s.name, 2)"/>
            </div>
            <div v-else><add-btn-sm  @click="onAdd(s.name, 2)">만들기</add-btn-sm></div>
          </td>
        </tr>
      </mdb-tbl-body>
    </mdb-tbl>
    <div v-if="this.mode==='TESTUNIT'">
      <div>
        <mdb-btn class="p-1 m-0 mr-2" icon="list" @click="onList">목록</mdb-btn>
        <save-btn-sm @click="onSaveTestUnit">저장</save-btn-sm>
      </div>
      <div>
        <div v-for="(unit, ux) in test.units" :key="unit._id" class="my-3">
          <div class="bolder">평가구분</div>
          <div class="clearfix">
            <input class="underline" v-model="unit.name" style="width:90%"/>
            <delete-btn-sm class="float-right" @click="test.units.splice(ux,1)"/>
          </div>
          <mdb-row>
            <mdb-col md="2" class="bolder text-right">평가항목</mdb-col>
            <mdb-col md="10">
              <div v-for="(content,ix) in unit.content" :key="ix">
                <input class="underline" v-model="unit.content[ix]" style="width:90%"/>
                <delete-btn-sm class="float-right" @click="unit.content.splice(ix, 1)"/>
              </div>
              <add-btn-sm @click="unit.content.push('')">항목 추가</add-btn-sm>
            </mdb-col>
          </mdb-row>
        </div>
        <add-btn-sm class="mt-3" @click="test.units.push({name: '', content: []})">평가 구분 추가</add-btn-sm>
      </div>
    </div>
    <perform-test-dlg v-if="task" :show="show" v-model="task" @ok="onOk" @close="onClose"/>
  </div>
</template>
<script>
import { } from 'mdbvue';
import PerformTestDlg from './PerformTestDlg.vue';
export default {
  name: 'NonNcsPerformTestList',
  components: { PerformTestDlg },
  props: ['subjects'],
  data: () => ({
    TAG: 'NonNcsPerformTestList :',
    tests: [],
    test: undefined,
    task: undefined,
    show: false,
    mode: 'LIST'
  }),
  computed: {
  },
  methods: {
    isTest (code, seq) {
      if (!this.tests || !this.tests[code]) return
      if (seq === 1 && this.tests[code].task1) {
        return this.tests[code].task1.testDate
      }
      if (seq === 2 && this.tests[code].task2) {
        return this.tests[code].task2.testDate
      }
    },
    // 1차 테스트 얻기
    task1 (code) {
      return this.tests[code].task1
    },
    // 2차 테스트 얻기
    task2 (code) {
      return this.tests[code].task2
    },
    // 테스트 추가
    onAdd (code, seq) {
      const test = this.tests[code]
      if (seq === 1 && !test) { // 1차이면서, 테스트가 없으면 생성
        const { training } = this.$route.query
        this.tests[code] = this.$PerformTest.create(training, code, code, code)
        // console.log('테스트 생성', this.tests[code])
      } else if (seq === 2) {
        test.task2 = {}
      }
      //  else if (seq === 2 && !test) { // 1차이면서, 테스트가 없으면 생성
      //   const { training } = this.$route.query
      //   this.tests[code] = this.$PerformTest.create(training, code, code, code)
      //   // console.log('테스트 생성', this.tests[code])
      // }
      // console.log(code, seq)
      this.onEdit(code, seq)
    },
    // 테스트 수정
    onEdit (code, seq) {
      this.show = true
      this.test = this.tests[code]
      this.task = seq === 1 ? this.test.task1 : this.test.task2
      console.log(this.test)
    },
    // 대화상자 OK 닫기
    async onOk () {
      if (!confirm('저장할까요?')) return
      await this.test.save()
      this.onClose()
    },
    // 대화상자 취소
    onClose () {
      this.show = false
      this.test = undefined
      this.task = undefined
    },
    // 목록 이동
    onList () {
      this.mode = 'LIST'
      this.test = undefined
    },
    async onDelete (code, seq) {
      if (!confirm('삭제할까요?')) return
      const test = this.tests[code]
      if (seq === 2) {
        test.task2 = { testDate: '' }
        await test.save()
      } else { // 완전 삭제
        await test.delete()
        this.tests[code] = undefined
      }
    },
    // 평가 기준 편집
    onEditTestUnit (code) {
      this.mode = 'TESTUNIT'
      this.test = this.tests[code]
    },
    async onSaveTestUnit () {
      if (!confirm('평가 기준을 저장할까요?')) return
      await this.test.save()
    }
  },
  async created () {
    const { training } = this.$route.query
    this.tests = await this.$PerformTest.list({ training })
  }
}
</script>
